import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash/isEmpty'
//import { defaultColDef } from 'pages/Output/TabellaDettaglio/config/table'
import FILTERED_TYPE from '@ublique/components/ColumnsFilterButtonTable/constant'
import { filter, isNull } from 'lodash'
import {
  defaultColDef,
  findAndSetAppliedFilter,
  getColumnsDef,
  tableActionsConfig
} from '../config/table'
import { useStoreSelector } from '@ublique/platform'
import { getReportPivotData } from 'api/ReportPivot'
import { useParams } from 'react-router-dom'

export const useStripeTablesConfig = () => {
  const { scenarioId } = useParams()

  const { t } = useTranslation(['OutputView'])
  const { t: agGridT } = useTranslation('agGrid')

  const [params, setParams] = useState()
  const [canSaveFilter, setCanSaveFilter] = useState(false)
  const [isActiveTabular, setIsActiveTabular] = useState(false)
  const [rowData, setRowData] = useState()

  const appliedNameFilter = useStoreSelector(
    'userPreferences',
    ({ output }) => {
      const filters = output?.filteredOutputColumns['report_pivot']
      return filters?.find(({ selected }) => selected)?.name ?? undefined
    }
  )

  useEffect(() => {
    async function fetchData() {
      //'Test_Dashboard'
      const response = await getReportPivotData({ scenarioId })
      setRowData(response)
      //setData(jdata)
    }
    fetchData()
  }, [scenarioId])

  const getColumnsWithState = () => {
    const columnsState = params.api.gridCore.columnApi.getColumnState()

    const enableColumns = filter(
      columnsState,
      ({ aggFunc, pivotIndex, rowGroupIndex }) =>
        !isNull(aggFunc) || !isNull(pivotIndex) || !isNull(rowGroupIndex)
    )

    return enableColumns
  }
  const userId = useStoreSelector('user', (user) => user.sub)

  const enableFilterBtn = {
    setIsActiveTabular,
    tabular: isActiveTabular,
    canSaveFilter,
    gridApi: params?.api,
    identifier: 'pivot',
    kind: 'output',
    type: FILTERED_TYPE.PIVOT,
    id: 'report_pivot',
    userId,
    t: agGridT
  }
  return {
    stripeTables: [
      {
        config: { sm: 4, md: 8, lg: 12 },
        tableProps: {
          onRowDataChanged: (params) => {
            findAndSetAppliedFilter(params)
          },
          onColumnPivotChanged: () => {
            const enableColumns = getColumnsWithState()
            setCanSaveFilter(isEmpty(enableColumns) ? false : true)
          },
          onColumnRowGroupChanged: () => {
            const enableColumns = getColumnsWithState()
            setCanSaveFilter(isEmpty(enableColumns) ? false : true)
          },
          onColumnValueChanged: () => {
            const enableColumns = getColumnsWithState()
            setCanSaveFilter(isEmpty(enableColumns) ? false : true)
          },
          extraHeaderComponent: {
            t: t,
            config: tableActionsConfig({
              btnFilterT: agGridT,
              t,
              gridApi: params?.api,
              isActiveTabular,
              setIsActiveTabular,
              enableFilterBtn,
              filterName: appliedNameFilter
            })
          },
          className: 'extraComponent',
          onGridReady: setParams,
          defaultColDef: defaultColDef,
          columnDefs: getColumnsDef(t),
          filter: false,
          canSearch: false,
          rowData,
          minHeight: '75vh',
          pivotMode: true,
          pivotRowTotals: 'after',
          groupIncludeFooter: true,
          groupIncludeTotalFooter: true,
          groupDisplayType: 'multipleColumns',
          autoGroupColumnDef: {
            minWidth: 180,
            cellRendererParams: {
              suppressCount: true
            }
          },
          enablePivot: {
            allFeature: true,
            groupIncludeFooter: true
            //suppressRowGroupExpand: true
          }
        }
      }
    ]
  }
}
